import { useEffect, useState } from "react";

/*
Higher order function which retuns a custom hook. getAPIHook accepts an async
function which is actually used to load an API. The returned useAPI function 
is a custom hook which returns an object with two properties:
- loading: Boolean of whether the API is still loading. Defaults to true.
- error: Any error that is thrown during the loading. Defaults to undefined.
*/
export default function getAPIHook(loader, injectPlayer) {
  return function useAPI() {
    const [loading, setLoading] = useState(Boolean(loader));
    const [error, setError] = useState();
    useEffect(() => {
      async function load() {
        try {
          if (loading) {
            await loader();
            setLoading(false);
          }
        } catch (error) {
          setError(error);
        }
      }
      injectPlayer && load();
    });
    return {
      loading,
      error
    };
  };
}